import template from './sw-cms-el-config-category-navigation.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
